<template>
    <div class="message-item__content--audio">
        <div class="audio"
            :class="{
                'is-playing': isPlaying
            }"
            :style="{
                width: width
            }"
            @click="toggleAudio">
            <span class="audio__duration">{{duration}}"</span>
            <svg class="audio__icon"
                width="16"
                height="17"
                viewBox="0 0 16 17"
                xmlns="http://www.w3.org/2000/svg">
                <g>
                    <path class="audio__icon-item" d="M12.93 8.526c0 .704.575 1.277 1.286 1.275.71 0 1.286-.57 1.284-1.277a1.28 1.28 0 0 0-1.284-1.275 1.283 1.283 0 0 0-1.286 1.277z" />
                    <path class="audio__icon-item" d="M10.198 4.677l-.06.059-.04.037-.054.057-.003.002a5.205 5.205 0 0 0 .003 7.397.928.928 0 0 0 .658.271c.513 0 .93-.416.93-.925v-.002a.91.91 0 0 0-.274-.652l-.002-.002a3.369 3.369 0 0 1 .002-4.786l.156-.155-.008-.009a.92.92 0 0 0 .18-.547V5.42a.912.912 0 0 0-.18-.542.936.936 0 0 0-1.302-.2l-.006-.001z" />
                    <path class="audio__icon-item" d="M6.993 2.755c-3.328 3.18-3.324 8.326.01 11.5a.895.895 0 0 0 .623.245c.484 0 .876-.376.874-.837a.808.808 0 0 0-.257-.59c-2.65-2.526-2.65-6.62 0-9.146a.812.812 0 0 0 .257-.592v-.002a.815.815 0 0 0-.257-.588.909.909 0 0 0-1.25.01z" />
                    <path class="audio__icon-item" d="M4.22.246l-.015.012C-1.408 4.816-1.4 12.2 4.22 16.752c.195.16.462.248.738.248C5.533 17 6 16.62 6 16.153v-.002a.766.766 0 0 0-.306-.596l-.012-.01C.882 11.648.888 5.332 5.694 1.44A.77.77 0 0 0 6 .843V.84a.766.766 0 0 0-.306-.595c-.407-.328-1.064-.328-1.474 0z" />
                </g>
            </svg>
        </div>
    </div>
</template>

<script>
    import uuid from 'uuid/v4'
    import translateMixin from './mixins/translate'

    const WIDTH_MAX = 245
    const WIDTH_MIN = 78
    const DURATION_MAX = 60

    export default {
        name: 'MessageContentAudio',
        mixins: [
            translateMixin
        ],
        props: {
            messageId: {
                type: String,
                required: true
            },
            media: {
                type: Object,
                required: true,
                validator (value) {
                    const { duration, localId, url } = value
                    if (!(
                        typeof duration === 'number' &&
                        !isNaN(duration)
                    )) {
                        return false
                    }
                    if (typeof localId !== 'string' && typeof url !== 'string') {
                        return false
                    }
                    return true
                }
            }
        },
        data () {
            return {
                type: 'audio',
                isPlaying: false,
                audioUUID: uuid()
            }
        },
        computed: {
            duration () {
                if (this.media) {
                    return Math.ceil(this.media.duration)
                }
                return 0
            },
            localId () {
                if (this.media) {
                    return this.media.localId
                }
                return undefined
            },
            url () {
                if (this.media) {
                    return this.media.url
                }
                return undefined
            },
            width () {
                let result = (this.duration / DURATION_MAX) * (WIDTH_MAX - WIDTH_MIN) + WIDTH_MIN
                if (result < WIDTH_MIN) {
                    result = WIDTH_MIN
                } else if (result > WIDTH_MAX) {
                    result = WIDTH_MAX
                }
                return result + 'px'
            }
        },
        methods: {
            toggleAudio () {
                if (this.isPlaying) {
                    this.$audioPlayer.stop()
                    this.isPlaying = false
                } else {
                    this.$audioPlayer.setUrl({
                        uuid: this.audioUUID,
                        url: this.url,
                        localId: this.localId
                    })
                    this.$nextTick(() => {
                        this.$audioPlayer.stop()
                        this.$audioPlayer.play()
                        this.isPlaying = true
                    })
                }
            }
        },
        created () {
            this.$eventBus.$on(`AUDIO_STOP_${this.audioUUID}`, () => {
                this.isPlaying = false
            })
        },
        beforeDestroy () {
            this.$eventBus.$off(`AUDIO_STOP_${this.audioUUID}`)
        }
    }
</script>

<style lang="scss" scoped>
    .audio {
        display: flex;
        align-items: center;
        height: 40px;
        cursor: pointer;

        &.is-playing {
            .audio__icon-item {
                &:nth-child(2) {
                    animation: fadeIn2 2s infinite both;
                }
                &:nth-child(3) {
                    animation: fadeIn3 2s infinite both;
                }
                &:nth-child(4) {
                    animation: fadeIn4 2s infinite both;
                }
            }
        }

        &__duration {
            font-size: 14px;
            line-height: 1;
        }

        &__icon {
            display: inline-block;
            width: 14px;
            height: 19px;

            &-item {
                fill: #fff;
            }
        }
    }

    .message-item--user {
        .audio {
            justify-content: flex-end;
            background-color: $primary-color;
            @include radius(.5, .25, .5, .5);

            &__icon {
                margin: 0 15px 0 10px;

                &-item {
                    fill: #fff;
                }
            }

            &__duration {
                color: #fff;
            }
        }
    }

    .message-item--service {
        .audio {
            justify-content: flex-end;
            flex-direction: row-reverse;
            background-color: #ffffff;
            @include radius(.25, .5, .5, .5);

            &__icon {
                margin: 0 10px 0 15px;
                transform: scale(-1, 1);

                &-item {
                    fill: #898989;
                }
            }

            &__duration {
                color: $primary-text-color;
            }
        }
    }


    @keyframes fadeIn2 {
        0%, 20% {
            opacity: 0
        }
        40%, 100% {
            opacity: 1
        }
    }

    @keyframes fadeIn3 {
        0%, 40% {
            opacity: 0
        }
        60%, 100% {
            opacity: 1
        }
    }

    @keyframes fadeIn4 {
        0%, 60% {
            opacity: 0
        }
        80%, 100% {
            opacity: 1
        }
    }
</style>
